import React, { useState, useEffect } from 'react'
import DataTable from 'react-data-table-component'
import { getStudentIdData } from '../../lib/studentbooklistview'
import { deleteIdData, addData } from '../../lib/studentbooklist'
import { useAuth } from '../../_helper/Auth/AuthProvider'
import { getBookListColumns } from '../../Data/BookList/BookListData'

export const BookList = ({ slug, isProfile = false }) => {
	const [booklist, setBookList] = useState([])
	const [filterText, setFilterText] = useState('')
	const [loading, setLoading] = useState(true)
	const { user } = useAuth()
	const isInstructorView = user?.role === 'Instructor'

	function getStudentBookData(bookId) {
		const result = booklist.filter((item) => item.bookId === bookId && item.id !== null)
		return result.length > 0 ? result[0].id : null
	}

	function getIsReadStatus(bookId) {
		const result = booklist.filter((item) => item.bookId === bookId)
		return result.length > 0 ? result[0].isRead || false : false
	}

	async function UpdateIsRead(Id, isRead, bookId) {
		try {
			const newReadStatus = !isRead

			if (Id === null) {
				await addData({
					isRead: newReadStatus,
					studentId: slug,
					bookId: bookId
				})
			} else {
				await deleteIdData(Id)
			}
			await GetData()
		} catch (error) {
			console.error('Error updating book read status:', error)
		}
	}

	function ChangeStatus(Id, isRead, bookId) {
		UpdateIsRead(Id, isRead, bookId)
	}

	async function GetData() {
		try {
			setLoading(true)
			const books = await getStudentIdData(slug)
			setBookList(books)
		} catch (error) {
			console.error('Error fetching book data:', error)
		} finally {
			setLoading(false)
		}
	}

	useEffect(() => {
		if (user && slug) {
			GetData()
		}
	}, [user, slug])

	const filteredBooks = booklist.filter(
		(item) =>
			item.title?.toLowerCase().includes(filterText.toLowerCase()) ||
			item.author?.toLowerCase().includes(filterText.toLowerCase()) ||
			item.bookId?.toString().includes(filterText)
	)

	// For College Profile view, show only books that have been read
	const displayBooks = isProfile ? filteredBooks.filter((item) => item.isRead) : filteredBooks

	const columns = getBookListColumns(getStudentBookData, getIsReadStatus, ChangeStatus, isProfile, isInstructorView)

	const customStyles = {
		headCells: {
			style: {
				fontSize: '14px',
				fontWeight: 'bold',
				textTransform: 'uppercase'
			}
		},
		rows: {
			style: {
				minHeight: '50px',
				fontSize: '14px'
			}
		},
		cells: {
			style: {
				paddingTop: '12px',
				paddingBottom: '12px',
				fontSize: '14px'
			}
		}
	}

	return (
		<div className="col-12">
			<div className="card shadow-sm mb-4" style={{ borderRadius: '8px' }}>
				
				<div className={isProfile ? '' : 'collapse'} id="collapseBookList">
					<div className="card-body">
						{!isProfile && (
							<div className="d-flex justify-content-between align-items-center mb-3">
								<h6 className="mb-0">Track books you have read</h6>
								<input
									type="text"
									placeholder="Search books..."
									className="form-control"
									style={{ maxWidth: '300px' }}
									value={filterText}
									onChange={(e) => setFilterText(e.target.value)}
								/>
							</div>
						)}
						{isProfile && (
							<div className="mb-3">
								<h6 className="mb-0">Reading List</h6>
							</div>
						)}

						{loading ? (
							<div className="text-center p-4">
								<div className="spinner-border" role="status">
									<span className="visually-hidden">Loading...</span>
								</div>
								<p className="mt-2">Loading books...</p>
							</div>
						) : (
							<DataTable
								columns={columns}
								data={displayBooks}
								pagination
								paginationPerPage={25}
								paginationRowsPerPageOptions={[10, 25, 50, 100]}
								highlightOnHover
								striped
								responsive
								dense
								persistTableHead
								customStyles={customStyles}
								noDataComponent={
									<div className="text-center p-4">
										<p className="text-muted">No books found</p>
									</div>
								}
							/>
						)}
					</div>
				</div>
			</div>
		</div>
	)
}
